import { render, staticRenderFns } from "./Signer.vue?vue&type=template&id=212cd83a&scoped=true&"
import script from "./Signer.vue?vue&type=script&lang=js&"
export * from "./Signer.vue?vue&type=script&lang=js&"
import style0 from "./Signer.vue?vue&type=style&index=0&id=212cd83a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212cd83a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
